/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkIsDefaultScheduleChangeRequestor,
  getUserEmailAddress,
  getWriteMenuPermissions,
} from '../../store/user/user-reducer';
import GenericGrid from '../grid/GenericGrid/GenericGrid';
import hooAccommodationsColumns, { hooColumnOrder } from '../grid/grid-configs/hoo-accommodations-columns';
import SeachHooRequests from '../header/search/SeachHooRequests';
import { acceptHooAccommodation, deleteHooAccommodation, rejectHooAccommodation, searchHoo } from './actions';
import AddHooRequestDrawer from './AddHooRequestDrawer';
import { getHooAccomodations, getLoading, getSearchHooRequests } from './selectors';

function HooAccommodations() {
  const dispatch = useDispatch();
  const loading = useSelector(getLoading);
  const gridColumns = hooAccommodationsColumns ?? [];
  const data = useSelector(getHooAccomodations);
  const search = useSelector(getSearchHooRequests);
  const [openDelete, setOpenDelete] = useState(false);
  const [openAccept, setOpenAccept] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [openRejectReason, setOpenRejectReason] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [rejectReason, setRejectReason] = useState('');
  const userEmailAddress = useSelector(getUserEmailAddress);
  const isDefaultScheduleChangeRequestor = useSelector(checkIsDefaultScheduleChangeRequestor);
  const [rejectReasonForm] = Form.useForm();
  // Drawer state
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isEditAllowed = useSelector(getWriteMenuPermissions)['hoo accommodations'];

  useEffect(() => {
    dispatch(searchHoo(search));
  }, [search]);

  const editDrawer = (record: any) => {
    setModalData(record);
    setIsDrawerOpen(true);
  };

  const deleteTemplate = (record: any) => {
    setDeleteId(record);
    setOpenDelete(true);
  };

  const onRequestAccept = (record: any) => {
    setDeleteId(record);
    setOpenAccept(true);
  };

  const onRequestDecline = (record: any) => {
    // Implement decline logic here
    setDeleteId(record);
    setOpenReject(true);
  };

  const handleAccept = (e: any) => {
    dispatch(acceptHooAccommodation({ requestId: deleteId, search: search }));
    setOpenAccept(false);
    setDeleteId(null);
  };

  const handleAcceptCancel = (e: any) => {
    setOpenAccept(false);
    setDeleteId(null);
  };

  const handleReject = (e: any) => {
    setOpenReject(false);
    setRejectReason('');
    rejectReasonForm.resetFields();
    setOpenRejectReason(true);
  };

  const handleRejectReasonOk = (e: any) => {
    dispatch(rejectHooAccommodation({ requestId: deleteId, search: search, rejectReason }));
    setOpenRejectReason(false);
    setRejectReason('');
    setDeleteId(null);
  };

  const handleRejectCancel = (e: any) => {
    setOpenReject(false);
    setOpenRejectReason(false);
    setRejectReason('');
    setDeleteId(null);
  };

  let filterValues = hooAccommodationsColumns(
    userEmailAddress,
    isDefaultScheduleChangeRequestor,
    isEditAllowed,
    search.statuses || [],
    editDrawer,
    deleteTemplate,
    onRequestAccept,
    onRequestDecline
  );

  const handleDelete = async (e: any) => {
    dispatch(await deleteHooAccommodation({ requestId: deleteId, search: search }));
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleDeleteCancel = (e: any) => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  // Drawer handlers
  const handleAddClick = () => {
    setModalData(null);
    setIsDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    setModalData(null);
  };
  const handleDrawerSubmit = (values: any) => {
    // Dispatch your create request action here
    dispatch(searchHoo(search));
    setIsDrawerOpen(false);
    setModalData(null);
  };

  return (
    <>
      <SeachHooRequests />
      {gridColumns.length > 0 && (
        <GenericGrid
          columns={filterValues}
          columnOrder={hooColumnOrder}
          data={data}
          sorting={[
            {
              id: 'EffectiveDate', // Column accessorKey or id
              desc: false, // false = ascending, true = descending
            },
          ]}
          enableRowSelection={false}
          rowSelection={[]}
          columnPinning={{}}
          filterDisplayMode='popover'
          highlightFilterMatch={true}
          paginationDisplayMode='pages'
          paginationProps={{
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            variant: 'outlined',
            rowsPerPageOptions: [10, 50, 100, 500, 1000],
          }}
          enableStickyHeader={true}
          enableStickyFooter={true}
          enableColumnPinning={true}
          isLoading={loading}
          enableAdd={isEditAllowed}
          onAddClick={handleAddClick}
          muiTableBodyCellProps={{
            sx: {
              fontSize: '11px',
              textAlign: 'left',
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              padding: '6px 10px',
              height: '40px',
              lineHeight: '1.2',
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontSize: '11px',
              fontWeight: 700,
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              textAlign: 'center',
              padding: '6px 10px',
              height: '40px',
              lineHeight: '1.2',
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              height: '40px',
              '& td': {
                padding: '6px 10px',
                height: '40px',
              },
              textAlign: 'center',
            },
          }}
          totalRecordsLabel='TOTAL REQUESTS'
        />
      )}
      <AddHooRequestDrawer
        open={isDrawerOpen}
        onClose={handleDrawerClose}
        onSubmit={handleDrawerSubmit}
        modalData={modalData}
        loading={loading}
      />
      <Modal
        title='Delete HOO Accommodation Request Confirmation'
        okText='Ok'
        centered
        style={{ top: 20 }}
        open={openDelete}
        onOk={(e) => handleDelete(e)}
        onCancel={handleDeleteCancel}
      >
        <span>Are you sure you wish to cancel this request?</span>
      </Modal>
      <Modal
        title='Accept HOO Accommodation Request Confirmation'
        okText='Ok'
        centered
        style={{ top: 20 }}
        open={openAccept}
        onOk={(e) => handleAccept(e)}
        onCancel={handleAcceptCancel}
      >
        <span>Are you sure you wish to accept this request?</span>
      </Modal>
      <Modal
        title='Reject HOO Accommodation Request Confirmation'
        okText='Ok'
        centered
        style={{ top: 20 }}
        open={openReject}
        onOk={(e) => handleReject(e)}
        onCancel={handleRejectCancel}
      >
        <span>Are you sure you wish to reject this request?</span>
      </Modal>

      <Modal
        title='Reject Reason'
        okText='Ok'
        centered
        style={{ top: 20 }}
        open={openRejectReason}
        onOk={(e) => handleRejectReasonOk(e)}
        onCancel={handleRejectCancel}
      >
        <Form layout='vertical' form={rejectReasonForm}>
          <Form.Item label='Reason for Request Rejection' name='rejectReason'>
            <TextArea
              required
              rows={3}
              maxLength={4000}
              placeholder='Enter reject reason...'
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default HooAccommodations;
